import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui réinitialise la position de défilement à chaque changement de route
 * Ce composant doit être placé à l'intérieur du Router dans l'application
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Remet la page tout en haut lors d'un changement de route
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Ce composant ne rend rien visuellement
};

export default ScrollToTop; 